import { EDIT_HTML_EMBED_EVENT, } from "../../plugins/HTMLTagAttachmentPlugin";
export const dispatchEditHTMLEmbedEvent = ({ nodeKey, html, }) => document.dispatchEvent(new CustomEvent(EDIT_HTML_EMBED_EVENT, {
    detail: { html, nodeKey },
}));
